module.exports = __webpack_public_path__ + "img/sketch-contact.439f4b50.svg";